import React from 'react';
import { shape, string } from 'prop-types';
import { Image } from '@thd-olt-component-react/image';
import { Facebook, Twitter, Pinterest } from '@thd-olt-component-react/social-media-links';
import styles from '../article-info.module.scss';

export const ContributorDetails = ({ contributorDetails, img, url }) => {
  const { contributorGuid, contributorImg, contributorName = '' } = contributorDetails;

  const fbURL = 'https://www.facebook.com/sharer/sharer.php?u=';
  const pinURL = 'https://pinterest.com/pin/create/button/?url=';
  const twitterURL = 'https://twitter.com/intent/tweet?url=';
  const baseLink = 'homedepot.com';

  const facebookProps = {
    href: `${fbURL}${baseLink}${url}`,
    shareable: true,
  };

  const pinterestProps = {
    href: `${pinURL}${baseLink}${url}&media=${img}`,
    shareable: true,
  };

  const twitterProps = {
    href: `${twitterURL}${baseLink}${url}`,
    shareable: true,
  };

  const contributorNameForURL = contributorName
    .split('')
    .filter((str) => !str.match(/^[^a-zA-Z0-9 ]+$/))
    .join('')
    .split(' ')
    .join('-')
    .toLowerCase();
  const authorBioHref = `/c/bio/${contributorNameForURL}/${contributorGuid}`;

  return (
    <>
      {contributorName ? (
        <div className={styles['article-info__contributor-details-container']}>
          <div>
            <Image src={contributorImg} alt="contributorImage" title={contributorName} />
          </div>
          <div className={styles['article-info__contributor-details-container__details']}>
            <a rel="nofollow" href={authorBioHref}>
              <h2>{`By: ${contributorName}`}</h2>
            </a>
            <div>
              <Facebook props={facebookProps} />
              <Pinterest props={pinterestProps} />
              <Twitter props={twitterProps} />
            </div>
            <h3>Share this article</h3>
          </div>
        </div>
      ) : (
        ''
      )}
    </>
  );
};

ContributorDetails.displayName = 'ContributorDetails';

ContributorDetails.propTypes = {
  url: string.isRequired,
  contributorDetails: shape({
    contributorGuid: string,
    contributorImg: string,
    contributorName: string,
  }).isRequired,
  img: string.isRequired,
};
